import { env } from '@src/env';

const getPartnerConfig = () => {
  try {
    const raw = localStorage.getItem('partnerConfig');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const SpinnerComponent = () => {
  const flavor = env.VITE_FLAVOR ? env.VITE_FLAVOR : 'default/';
  const base = env.VITE_PUBLIC_PATH || '/';
  const partnerConfig = getPartnerConfig();
  const logo =
    partnerConfig?.logo1Url && partnerConfig?.imagesUrl
      ? `${partnerConfig.imagesUrl}/partnerAssets/${partnerConfig.logo1Url}`
      : `${base}assets/${flavor}logo.png`;

  return (
    <div className="fallback-spinner vh-100">
      <img className="fallback-logo" src={logo} alt="logo" />
      <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
    </div>
  );
};

export default SpinnerComponent;
